import { config } from 'config'
import { requestAPI } from 'utils/api'

export const createAccount = (params: { [x: string]: any }) => {
  return requestAPI({
    method: 'POST', url: `/auth/signup`, params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) }).finally(() => {
    return Promise.all(config.commonURL.map((url: string) => {
      return requestAPI({
        method: 'POST', url: `${url}/auth/dbsignup`, params
      })
    }))
  })
}

export const loginAccount = (params: {
  email: string;
  password: string;
}) => {
  return requestAPI({
    method: 'POST', url: '/auth/login', params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const requestAccountToken = () => {
  return requestAPI({
    method: 'GET', url: '/auth/token'
  }).then((result) => {
    return result.data
  }).catch(error => { throw JSON.parse(error) })
}